import { GET } from './restMethods';
import STATUS_CODES from 'constants/statusCodes';

const IGNORED_ENDPOINTS_AND_STATUSES = [
	{
		matcher: /^\/api\/vehicle_inspections\/\d+\/buyer_inspection_notes$/,
		method: GET,
		ignoredStatuses: [STATUS_CODES.NOT_FOUND],
	},
];

export const ignoreErrorsForCertainEndpoints = (error, url, method) => {
	return IGNORED_ENDPOINTS_AND_STATUSES.some(
		(endpoint) =>
			endpoint.method === method && endpoint.ignoredStatuses.includes(error.status) && endpoint.matcher.test(url), // ensure test is the last check to avoid unnecessary regex evaluation
	);
};
